<template>
    <div class="article-home-shoes">
        <p>Love the shoes that Lauren wears in videos? Simply must know what they are? Find out here.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleHomeShoes',
};
</script>
